/* ===== BRM MENU - 7 Oct 2026 =====
   Script for Vikas's change 07 (hamburger on desktop) and change 08 (text-only menu).
   Works WITH the theme's own menu code (theme.min.js opens and closes nav.navigation and turns the
   header hamburger into a cross); this file never opens or closes the menu by itself, it only clicks
   the theme's hamburger button, so the theme stays in charge.
   1. "+ 4 more" / "Show less" in Collections and Categories.
   2. The menu's links stay out of the keyboard order while the menu is closed.
   3. The theme reveals its small links one by one (about 3 seconds, and the cross does not answer
      until that is over). Those links now simply show with the menu, so it answers at once.
   4. 768px and up (panel): close button, click on the dimmed page closes, the page behind does not
      scroll, keyboard focus goes into the panel and stays there until it closes, and the page does
      not jump back to the top when the menu closes.
   5. Scroll-up bar hamburger on 768px and up opens the panel straight away (phones keep the old
      scroll-to-top-then-open behaviour from snippets/br-nav.liquid).
   Undo: delete the line that loads this file in sections/header.liquid. */
(function () {
  'use strict';
  var d = document, w = window;
  if (w.brmMenu) return;
  w.brmMenu = { version: '2026-10-07' };

  var PANEL = '(min-width: 768px)';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';

  function panel() { try { return w.matchMedia(PANEL).matches; } catch (e) { return false; } }
  function navEl() { return d.querySelector('nav.navigation'); }
  function burger() { return d.querySelector('.site-header .site-header__navigation'); }
  function isOpen() { return !!d.body && d.body.classList.contains('navigation-open'); }
  function shown(el) {
    if (!el || el.hidden) return false;
    var r = el.getClientRects();
    if (!r.length) return false;
    var cs = w.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && !(r[0].width <= 1 && r[0].height <= 1);
  }
  function toggleMenu() { var b = burger(); if (b) b.click(); }

  function init() {
    var nav = navEl();
    if (!nav || !nav.querySelector('.brm-dr')) return;
    var dr = nav.querySelector('.brm-dr');
    var cont = nav.querySelector('.navigation__container') || dr;
    var btn = burger();

    /* the header hamburger: a real button with a name, not a "navigation" landmark */
    if (btn) {
      if (btn.getAttribute('role') === 'navigation') btn.removeAttribute('role');
      if (!nav.id) nav.id = 'brm-nav';
      btn.setAttribute('aria-controls', nav.id);
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Menu');
    }

    /* 3. no one-by-one reveal: those links show together with the menu */
    Array.prototype.forEach.call(nav.querySelectorAll('.navigation__entrance-animation'), function (el) {
      el.classList.remove('navigation__entrance-animation');
    });

    /* 2. closed menu out of the keyboard order (the theme takes these off again when it opens the menu) */
    function setTabbable(on) {
      Array.prototype.forEach.call(dr.querySelectorAll('a[href], button'), function (el) {
        if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
      });
    }
    if (!isOpen()) setTabbable(false);

    /* 1. "+ n more" / "Show less" */
    dr.addEventListener('click', function (e) {
      var more = e.target.closest ? e.target.closest('.brm-more') : null;
      if (more && dr.contains(more)) {
        e.preventDefault();
        var list = d.getElementById(more.getAttribute('aria-controls'));
        if (!list) return;
        var open = more.getAttribute('aria-expanded') !== 'true';
        list.hidden = !open;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var first = list.querySelector('a[href]'); if (first && panel()) { try { first.focus({ preventScroll: true }); } catch (x) {} } }
        return;
      }
      var x = e.target.closest ? e.target.closest('.brm-x') : null;
      if (x && dr.contains(x)) { e.preventDefault(); if (isOpen()) toggleMenu(); }
    });

    /* 4. panel: a click on the dimmed page closes the menu */
    nav.addEventListener('click', function (e) {
      if (panel() && isOpen() && e.target === nav) toggleMenu();
    });

    /* 4. panel: the page behind does not scroll while the menu is open */
    function lockScroll(e) {
      if (!panel() || !isOpen()) return;
      var t = e.target;
      if (!cont.contains(t) || cont.scrollHeight <= cont.clientHeight + 1) { e.preventDefault(); return; }
      if (e.type === 'wheel') {
        var dy = e.deltaY || 0;
        var atTop = cont.scrollTop <= 0, atEnd = cont.scrollTop + cont.clientHeight >= cont.scrollHeight - 1;
        if ((dy < 0 && atTop) || (dy > 0 && atEnd)) e.preventDefault();
      }
    }
    nav.addEventListener('wheel', lockScroll, { passive: false });
    nav.addEventListener('touchmove', function (e) {
      if (!panel() || !isOpen()) return;
      if (!cont.contains(e.target) || cont.scrollHeight <= cont.clientHeight + 1) e.preventDefault();
    }, { passive: false });

    /* 4. keyboard: focus into the panel when it opens, Tab stays inside the menu while it is open */
    function stops() {
      var list = Array.prototype.filter.call(cont.querySelectorAll(FOCUSABLE), function (el) {
        return el.getAttribute('tabindex') !== '-1' && shown(el);
      });
      var b = burger();
      if (!panel() && b && shown(b)) list.unshift(b); /* phones: the header cross closes the menu */
      return list;
    }
    d.addEventListener('keydown', function (e) {
      if (!isOpen() || (e.key !== 'Tab' && e.keyCode !== 9)) return;
      var s = stops(); if (!s.length) return;
      var i = s.indexOf(d.activeElement), last = s.length - 1;
      if (e.shiftKey) { if (i <= 0) { e.preventDefault(); s[last].focus(); } }
      else if (i === -1 || i === last) { e.preventDefault(); s[0].focus(); }
    });

    /* watch the theme open and close the menu */
    var wasOpen = isOpen(), savedY = 0, guardUntil = 0;
    new MutationObserver(function () {
      var now = isOpen();
      if (now === wasOpen) return;
      wasOpen = now;
      if (now) {
        savedY = w.pageYOffset || d.documentElement.scrollTop || 0;
        setTabbable(true);
        if (panel()) {
          cont.scrollTop = 0;
          var x = dr.querySelector('.brm-x');
          setTimeout(function () { if (isOpen() && x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } } }, 30);
        }
      } else {
        guardUntil = Date.now() + 2500;
      }
    }).observe(d.body, { attributes: true, attributeFilter: ['class'] });

    /* 4. when it closes the theme puts focus back on the header hamburger; if the menu was opened
       from the scroll-up bar further down the page, that would scroll the page back to the top */
    if (btn) btn.addEventListener('focus', function () {
      if (!panel() || Date.now() > guardUntil || savedY < 5) return;
      var y = savedY;
      function back() { if (Math.abs((w.pageYOffset || 0) - y) > 2) w.scrollTo(0, y); }
      back(); setTimeout(back, 0);
      if (w.requestAnimationFrame) w.requestAnimationFrame(back);
      var sb = d.querySelector('#br-sticky .br-sticky__burger');
      if (sb && shown(sb)) { try { sb.focus({ preventScroll: true }); } catch (e) {} }
    });

    /* 5. scroll-up bar hamburger on 768px and up: open the panel where you are */
    d.addEventListener('click', function (e) {
      var sb = e.target.closest ? e.target.closest('#br-sticky .br-sticky__burger') : null;
      if (!sb || !panel()) return;
      e.preventDefault(); e.stopPropagation();
      if (!isOpen()) toggleMenu();
    }, true);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
/* ===== END BRM MENU ===== */
